import { render, staticRenderFns } from "./ChartModule.vue?vue&type=template&id=088bb2ba"
import script from "./ChartModule.vue?vue&type=script&lang=js"
export * from "./ChartModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports